//TODO: temporary solution only for Indices category
import { localStorageService } from '@trader/services';
import { LOCAL_STORAGE_KEYS } from '@trader/constants';

const calc = 100;
export const calculateIndicesPips = (
  pips: number,
  type: 'toPips' | 'toRate'
): string => {
  const category: string =
    localStorageService.get(LOCAL_STORAGE_KEYS.category) || '';
  let result = pips;
  if (category === 'Indices') {
    result = type === 'toPips' ? pips / calc : pips * calc;
    return result.toString();
  }
  return result.toString();
};
